<template>
  <v-container fluid class="ma-0 pa-0" style="height:100%">
    <v-row style="height: 100%" class="ma-0 pa-0">
      <v-col cols="2" md="2" class="d-none d-sm-flex">
        <v-list flat class="fill-height" style="background-color: #FFFFFF">
          <v-subheader style="margin: 65px auto 110px;">
            <a href="https://whatsredirect.com.br" target="_blanck">
              <v-img src="/img/WR_positivaMin.png" width="100%"></v-img>
            </a>
          </v-subheader>
          <v-list-item-group v-model="menuIndex" color="primary">
            <v-list-item
              disabled
              v-for="(listItem, i) in menuItens"
              :key="i"
              v-bind:style="{
                'background-color':
                  menuIndex == listItem.id ? '#F8FAFB' : '#FFFFFF'
              }"
            >
              <v-list-item-avatar
                v-if="listItem.alwaysShow || registerInfo.plan.original > 0"
              >
                <v-chip
                  v-if="menuIndex > listItem.id"
                  color="secondary"
                  small
                  style="padding:0 6px"
                >
                  <v-icon x-small>fas fa-check</v-icon>
                </v-chip>
                <v-chip v-else color="primary" small style="padding:0 9px">
                  {{ listItem.id + 1 }}
                </v-chip>
              </v-list-item-avatar>
              <v-list-item-content
                v-if="listItem.alwaysShow || registerInfo.plan.original > 0"
              >
                <v-list-item-title>
                  <span
                    v-if="menuIndex == listItem.id"
                    style="font-weight:600"
                    >{{ listItem.title }}</span
                  >
                  <span v-else>{{ listItem.title }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        cols="12"
        md="10"
        v-bind:class="{ 'mx-0': isMobile, 'px-0': isMobile }"
      >
        <v-row class="mx-0">
          <v-col cols="5" class="mx-0 d-flex d-sm-none">
            <a href="https://whatsredirect.com.br" target="_blanck">
              <v-img
                src="/img/WR_positivaMin.png"
                width="100px"
                contain
              ></v-img>
            </a>
          </v-col>
          <v-col
            cols="7"
            md="12"
            align-self="center"
            class="pb-0 mb-0 mx-0 pl-0"
            style="text-align:right"
          >
            <span class="mx-3"
              >Já possui uma conta?
              <v-btn color="success" class="px-2" v-on:click="gotoLogin()" text
                >Entre Agora!</v-btn
              >
            </span>
          </v-col>
          <v-col cols="12" class="d-flex d-sm-none my-1 py-1">
            <v-row class="my-0 py-0" justify="center">
              <v-col class="my-0 py-0 stepperMobile">
                <span>
                  <v-chip
                    v-if="menuIndex > 0"
                    color="secondary"
                    small
                    style="padding:0 6px"
                  >
                    <v-icon x-small>fas fa-check</v-icon>
                  </v-chip>
                  <v-chip
                    v-else
                    :color="menuIndex == 0 ? 'secondary' : 'primary'"
                    small
                    style="padding:0 9px"
                    >1</v-chip
                  > </span
                ><br />
                <span>Planos</span>
              </v-col>
              <v-col
                align-self="center"
                cols="1"
                class="my-0 py-0 stepperMobile"
              >
                <span>></span>
              </v-col>
              <v-col class="my-0 py-0 stepperMobile">
                <span>
                  <v-chip
                    v-if="menuIndex > 1"
                    color="secondary"
                    small
                    style="padding:0 6px"
                  >
                    <v-icon x-small>fas fa-check</v-icon>
                  </v-chip>
                  <v-chip
                    v-else
                    :color="menuIndex == 1 ? 'secondary' : 'primary'"
                    small
                    style="padding:0 9px"
                    >2</v-chip
                  > </span
                ><br />
                <span>Dados</span>
              </v-col>
              <v-col
                align-self="center"
                cols="1"
                class="my-0 py-0 stepperMobile"
                v-if="registerInfo.plan.original > 0"
              >
                <span>></span>
              </v-col>
              <v-col
                class="my-0 py-0 stepperMobile"
                v-if="registerInfo.plan.original > 0"
              >
                <span>
                  <v-chip
                    :color="menuIndex == 2 ? 'secondary' : 'primary'"
                    small
                    style="padding:0 9px"
                    >3</v-chip
                  > </span
                ><br />
                <span>Pagamento</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="menuIndex == 0" class="py-0 my-0">
            <v-container fluid class="ma-0 pa-0">
              <v-row no-gutters>
                <v-col cols="12" v-if="isMobile">
                  <v-carousel
                    v-model="planPage"
                    show-arrows
                    hide-delimiters
                    prev-icon="fas fa-angle-left"
                    next-icon="fas fa-angle-right"
                    light
                    height="700"
                  >
                    <v-carousel-item
                      v-for="plan in plans"
                      :key="'plan_' + plan.id"
                    >
                      <v-container fluid class="py-0 my-0">
                        <v-row class="py-0 my-0">
                          <v-col cols="12" class="pa-0 ma-0">
                            <plan-card
                              :plan="plan"
                              v-model="selectedDays"
                              v-on:select-plan="selectPlan($event)"
                            ></plan-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-carousel-item>
                  </v-carousel>
                </v-col>
                <v-col
                  cols="3"
                  v-for="plan in plans"
                  :key="'plan_' + plan.id"
                  class="pr-2"
                  v-else
                >
                  <plan-card
                    :plan="plan"
                    v-model="selectedDays"
                    v-on:select-plan="selectPlan($event)"
                  ></plan-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" v-if="menuIndex == 1" class="pt-0 mt-0">
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-0 mt-0"
                  v-bind:class="{ 'mx-0': isMobile, 'px-0': isMobile }"
                >
                  <v-card>
                    <v-container fluid>
                      <v-row>
                        <v-col
                          cols="12"
                          v-bind:class="{ 'mx-0': isMobile, 'px-0': isMobile }"
                        >
                          <v-form
                            lazy-validation
                            ref="form"
                            v-model="formValid"
                          >
                            <v-container fluid class="my-0 py-0">
                              <v-row>
                                <v-col cols="12" class="my-1 py-1">
                                  <span class="user-data-subtitle"
                                    >Dados de acesso:</span
                                  >
                                </v-col>
                                <v-col cols="12" md="4" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.user.name"
                                    label="Nome Completo"
                                    :rules="rules.required"
                                    name="name"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.user.email"
                                    label="E-mail"
                                    type="email"
                                    :rules="rules.emailRules"
                                    name="email"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.user.pass"
                                    type="password"
                                    label="Senha"
                                    :rules="rules.passRules"
                                    name="pass"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.user.confirm"
                                    label="Confirme a Senha"
                                    type="password"
                                    :rules="[
                                      (v) =>
                                        v == registerInfo.user.pass ||
                                        'Precisa ser igual a senha',
                                      (v) => !!v || 'Este campo é obrigatório'
                                    ]"
                                    name="confirm"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mt-0 pt-0">
                                  <v-checkbox
                                    v-model="acceptedToS"
                                    :rules="[
                                      (v) =>
                                        !!v ||
                                        'Você precisa aceitar para continuar'
                                    ]"
                                  >
                                    <template v-slot:label>
                                      <div>
                                        Eu li e concordo com os
                                        <tos
                                          :register="true"
                                          :time="registerInfo.user.tosTime"
                                          v-on:update="
                                            registerInfo.user.tosTime = $event
                                          "
                                        ></tos>
                                        do WhatsRedirect
                                      </div>
                                    </template>
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row v-if="registerInfo.plan.price > 0">
                                <v-col cols="12" class="my-1 py-1">
                                  <span class="user-data-subtitle"
                                    >Informações de Cliente:</span
                                  >
                                </v-col>
                                <v-col cols="12" class="my-0 py-0">
                                  <v-radio-group
                                    dense
                                    row
                                    class="my-0 py-0"
                                    v-model="registerInfo.client.type"
                                  >
                                    <v-radio value="1">
                                      <template v-slot:label>
                                        <div>
                                          Pessoa Física
                                        </div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="2">
                                      <template v-slot:label>
                                        <div>
                                          Pessoa Jurídica
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="2"
                                  class="my-0 py-0"
                                  v-if="registerInfo.client.type == 1"
                                >
                                  <v-text-field
                                    v-model="registerInfo.client.doc"
                                    label="CPF"
                                    type="tel"
                                    name="cpf"
                                    v-mask="['###.###.###-##']"
                                    v-on:blur="validateDoc()"
                                    :rules="[
                                      (v) => !!v || 'Este campo é obrigatório',
                                      validDoc ||
                                        'O documento precisa ser válido'
                                    ]"
                                    required
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="8"
                                  md="2"
                                  class="my-0 py-0"
                                  v-if="registerInfo.client.type == 2"
                                >
                                  <v-text-field
                                    v-model="registerInfo.client.doc"
                                    v-on:blur="validateDoc()"
                                    :rules="[
                                      validDoc || 'CNPJ Inválido',
                                      (v) => !!v || 'Este campo é obrigatório'
                                    ]"
                                    type="tel"
                                    label="CNPJ"
                                    v-mask="['##.###.###/####-##']"
                                    name="cnpj"
                                    required
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="5"
                                  class="my-0 py-0"
                                  v-if="registerInfo.client.type == 2"
                                >
                                  <v-text-field
                                    v-model="registerInfo.client.razao"
                                    label="Razão Social"
                                    :rules="rules.required"
                                    name="razao_social"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                  class="my-0 py-0"
                                  v-if="registerInfo.client.type == 2"
                                >
                                  <v-text-field
                                    v-model="registerInfo.client.fantasia"
                                    label="Nome Fantasia"
                                    :rules="rules.required"
                                    name="fantasia"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.client.phone"
                                    label="Telefone"
                                    :rules="rules.required"
                                    v-mask="[
                                      '(##) ####-####',
                                      '(##) #####-####'
                                    ]"
                                    type="tel"
                                    name="phone"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row v-if="registerInfo.plan.price > 0">
                                <v-col cols="12" class="my-1 py-1">
                                  <span class="user-data-subtitle"
                                    >Endereço:</span
                                  >
                                </v-col>
                                <v-col cols="5" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.cep"
                                    label="CEP"
                                    type="tel"
                                    name="cep"
                                    v-mask="'#####-###'"
                                    :rules="rules.required"
                                    v-on:blur="getAddress()"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="7"
                                  md="10"
                                  class="my-0 py-0"
                                ></v-col>
                                <v-col cols="8" md="4" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.street"
                                    label="Endereço"
                                    :rules="rules.required"
                                    name="address"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="4" md="1" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.number"
                                    label="Número"
                                    name="street_number"
                                    :rules="rules.required"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.complement"
                                    label="Complemento"
                                    name="complement"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.neighborhood"
                                    label="Bairro"
                                    :rules="rules.required"
                                    name="neighborhood"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="8" md="2" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.city"
                                    label="Cidade"
                                    :rules="rules.required"
                                    name="city"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="4" md="1" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.address.state"
                                    label="Estado"
                                    :rules="rules.required"
                                    v-mask="'AA'"
                                    name="state"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions>
                      <v-container fluid>
                        <v-row justify="space-between">
                          <v-col cols="12">
                            <v-btn color="warning" v-on:click="menuIndex--"
                              >Anterior</v-btn
                            >
                            <v-btn
                              v-if="this.registerInfo.plan.original != 0"
                              color="secondary"
                              style="float:right"
                              v-on:click="validateForm()"
                              >Pŕoximo</v-btn
                            >
                            <v-btn
                              v-else
                              color="secondary"
                              :loading="loading"
                              v-on:click="finalizeRegister()"
                              style="float:right"
                              >Finalizar</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" v-if="menuIndex == 2" class="pt-0 mt-0">
            <v-container fluid>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-0 mt-0"
                  v-bind:class="{ 'mx-0': isMobile, 'px-0': isMobile }"
                >
                  <v-form lazy-validation ref="form" v-model="formValid">
                    <v-card>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" md="9" order-md="1" order="2">
                            <div v-if="this.registerInfo.plan.price == 0">
                              <v-row style=" filter: opacity(0.15);">
                                <v-col cols="12" style="height:2500px">
                                  <v-img
                                    src="/img/WR_Only_R.png"
                                    contain
                                    max-height="150px"
                                    style="margin-top: 30px;"
                                  >
                                  </v-img>
                                </v-col>
                              </v-row>
                            </div>
                            <div v-else>
                              <v-row>
                                <v-col cols="12" class="mt-0 pt-0">
                                  <span class="user-data-subtitle"
                                    >Dados de Pagamento</span
                                  >
                                </v-col>
                              </v-row>
                              <v-row v-if="allowBoleto">
                                <v-col cols="12" class="my-0 py-0">
                                  <v-radio-group
                                    dense
                                    :row="!isMobile"
                                    class="my-0 py-0"
                                    label="Forma de pagamento:"
                                    v-model="registerInfo.billing.type"
                                  >
                                    <v-radio value="1">
                                      <template v-slot:label>
                                        <div>
                                          Cartão de Crédito
                                        </div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="2">
                                      <template v-slot:label>
                                        <div>
                                          Boleto Bancário
                                        </div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  registerInfo.billing.type == '2' && !isMobile
                                "
                                style=" filter: opacity(0.15);"
                              >
                                <v-col cols="12" style="height:300px">
                                  <v-img
                                    src="/img/WR_Only_R.png"
                                    contain
                                    max-height="150px"
                                    style="margin-top:75px;"
                                  >
                                  </v-img>
                                </v-col>
                              </v-row>
                              <v-row v-if="registerInfo.billing.type == '1'">
                                <v-col cols="12" class="my-2 py-2">
                                  <span class="title-billing"
                                    >Dados do Cartão de crédito:</span
                                  >
                                </v-col>
                                <v-col
                                  cols="8"
                                  order="1"
                                  order-md="1"
                                  md="3"
                                  class="my-0 py-0"
                                >
                                  <v-text-field
                                    v-model="registerInfo.billing.card.number"
                                    label="Número do Cartão"
                                    name="card_number"
                                    type="tel"
                                    dense
                                    v-mask="'#### #### #### ####'"
                                    :rules="rules.required"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="8"
                                  order="3"
                                  order-md="2"
                                  md="3"
                                  class="my-0 py-0"
                                >
                                  <v-text-field
                                    v-model="registerInfo.billing.card.holder"
                                    label="Titular do Cartão"
                                    name="card_holder"
                                    dense
                                    :rules="rules.required"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="4"
                                  md="2"
                                  order="4"
                                  order-md="3"
                                  class="my-0 py-0"
                                >
                                  <v-text-field
                                    v-model="registerInfo.billing.card.expire"
                                    label="Validade"
                                    name="card_expire"
                                    placeholder="MM/AAAA"
                                    type="tel"
                                    dense
                                    v-mask="'##/####'"
                                    :rules="rules.dateCard"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="4"
                                  order="2"
                                  order-md="4"
                                  md="1"
                                  class="my-0 py-0"
                                >
                                  <v-text-field
                                    v-model="registerInfo.billing.card.cvv"
                                    label="CVV"
                                    name="card_cvv"
                                    type="tel"
                                    dense
                                    v-mask="['###', '####']"
                                    :rules="rules.required"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                  order="5"
                                  class="my-0 py-0"
                                >
                                  <v-select
                                    dense
                                    :items="allowedInstallments"
                                    v-model="registerInfo.billing.installments"
                                    :disabled="allowedInstallments.length == 1"
                                    :ref="installmentsRef"
                                    item-text="text"
                                    item-value="value"
                                    label="Parcelas"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="8"
                                  order="6"
                                  order-md="6"
                                  md="3"
                                  class="my-0 py-0"
                                >
                                  <v-text-field
                                    v-model="registerInfo.billing.card.cpf"
                                    label="CPF do Titular"
                                    v-mask="['###.###.###-##']"
                                    type="tel"
                                    name="card_holder_cpf"
                                    dense
                                    :rules="rules.required"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row v-if="registerInfo.billing.type == '1'">
                                <v-col cols="12" class="my-2 py-2">
                                  <span class="title-billing"
                                    >Endereço de cobrança:</span
                                  >&nbsp;&nbsp;&nbsp;&nbsp;
                                  <span
                                    class="sub-billing"
                                    v-on:click="setBillingAddress(true)"
                                    >Utilizar meu Endereço</span
                                  >
                                </v-col>
                                <v-col cols="5" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.billing.address.cep"
                                    label="CEP"
                                    name="cep"
                                    type="tel"
                                    dense
                                    v-mask="'#####-###'"
                                    :rules="rules.required"
                                    v-on:blur="getAddress(true)"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="8" md="6" class="my-0 py-0">
                                  <v-text-field
                                    v-model="
                                      registerInfo.billing.address.street
                                    "
                                    label="Endereço"
                                    :rules="rules.required"
                                    dense
                                    name="address"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="
                                      registerInfo.billing.address.number
                                    "
                                    label="Número"
                                    name="street_number"
                                    dense
                                    :rules="rules.required"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="
                                      registerInfo.billing.address.complement
                                    "
                                    label="Complemento"
                                    dense
                                    name="complement"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="
                                      registerInfo.billing.address.neighborhood
                                    "
                                    label="Bairro"
                                    :rules="rules.required"
                                    dense
                                    name="neighborhood"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.billing.address.city"
                                    label="Cidade"
                                    :rules="rules.required"
                                    dense
                                    name="city"
                                    required
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" class="my-0 py-0">
                                  <v-text-field
                                    v-model="registerInfo.billing.address.state"
                                    label="Estado"
                                    :rules="rules.required"
                                    v-mask="'AA'"
                                    dense
                                    name="state"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            order="2"
                            md="3"
                            order-md="2"
                            class="resume mr-0 pr-0"
                          >
                            <v-col cols="12" class="mt-0 pt-0">
                              <span class="user-data-subtitle"
                                >Resumo da Compra</span
                              >
                            </v-col>
                            <v-col cols="12" class="ma-0 pa-0">
                              <v-card-text class="mb-0 pb-0">
                                <v-row>
                                  <v-col cols="6" md="12" class="my-0 py-0">
                                    <div>Plano:</div>
                                    <p class="resume-info">
                                      {{ formatPlanResumeInfo.name }}
                                    </p>
                                  </v-col>
                                  <v-col cols="6" md="12" class="my-0 py-0">
                                    <div>Período:</div>
                                    <p class="resume-info">
                                      {{ formatPlanResumeInfo.period }}
                                    </p>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="12"
                                    offset="6"
                                    offset-md="0"
                                    class="my-0 py-0"
                                  >
                                    <div>Valor:</div>
                                    <p class="resume-info">
                                      {{ formatPlanResumeInfo.price }}
                                    </p>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="12"
                                    offset="6"
                                    offset-md="0"
                                    class="my-0 py-0"
                                  >
                                    <p class="resume-parcelas">
                                      {{ registerInfo.billing.installments }}x
                                      de R$
                                      {{
                                        formatAsPrice(
                                          registerInfo.plan.price /
                                            registerInfo.billing.installments
                                        )
                                      }}
                                    </p>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">
                              <v-text-field
                                label="Cupom de Desconto"
                                class="discountfield"
                                dense
                                v-model="registerInfo.billing.discountCode"
                                :rules="[validCupom || 'Cupom não validado']"
                              >
                                <template v-slot:append-outer>
                                  <v-btn
                                    icon
                                    color="success"
                                    :loading="discountCode.loading"
                                    v-on:click="checkDiscount()"
                                  >
                                    <v-icon>fas fa-plus-circle</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                              <div v-if="formatPlanResumeInfo.hasDiscount">
                                <div>Desconto aplicado:</div>
                                <p class="resume-info">
                                  {{ formatPlanResumeInfo.discount }} &nbsp;
                                  <v-chip color="#fbce3b" x-small
                                    >-{{
                                      formatPlanResumeInfo.discountPerc
                                    }}%</v-chip
                                  >
                                </p>
                              </div>
                            </v-col>

                            <v-col cols="12" class="ma-0 pa-0">
                              <v-card-text
                                class="mb-0 pb-0"
                                style="text-align: end;"
                              >
                                <div>Total:</div>
                                <p class="resume-info">
                                  <strike
                                    v-if="formatPlanResumeInfo.hasDiscount"
                                    >{{ formatPlanResumeInfo.original }}</strike
                                  >&nbsp;
                                  <span>{{ formatPlanResumeInfo.price }}</span>
                                </p>
                              </v-card-text>
                            </v-col>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-container fluid>
                          <v-row justify="space-between">
                            <v-col cols="12">
                              <v-btn color="warning" v-on:click="menuIndex--"
                                >Anterior</v-btn
                              >
                              <v-btn
                                color="secondary"
                                :loading="loading"
                                v-on:click="finalizeRegister()"
                                style="float:right"
                                >Finalizar</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <span class="googleReCaptcha">
          Este site é protegido pelo reCAPTCHA e a
          <a href="https://policies.google.com/privacy" target="_blank"
            >Política de Privacidade</a
          >&nbsp;e os &nbsp;
          <a href="https://policies.google.com/terms" target="_blank"
            >Termos de Serviço</a
          >
          da Google se aplicam.
        </span>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="discountCode.show"
      bottom
      right
      :color="discountCode.status"
      :timeout="3000"
    >
      {{ discountCode.msg }}
    </v-snackbar>
  </v-container>
</template>
<script>
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";
import Axios from "axios";
import Swal from "sweetalert2";
import planCard from "./../../components/modules/planCard.vue";
import tos from "./../../components/modules/tos.vue";

Vue.use(VueReCaptcha, { siteKey: "6Le1RPcUAAAAAMcqJ87Ga3y4zVDmtfVKPAeXOyAZ" });
export default {
  name: "Login",
  directives: { mask },
  components: { planCard, tos },
  data: () => ({
    planPage: 2,
    menuIndex: 0,
    menuItens: [
      { id: 0, alwaysShow: true, title: "Escolha seu Plano" },
      { id: 1, alwaysShow: true, title: "Seus Dados" },
      { id: 2, alwaysShow: false, title: "Resumo" }
    ],
    loadingPlans: false,
    installmentsRef: 0,
    allowedInstallments: [{ value: 1, text: "1x" }],
    selectedDays: 90,
    formValid: true,
    reCaptchaPassed: false,
    discountPrice: Infinity,
    allowBoleto: false,
    loading: false,
    acceptedToS: false,
    registerInfo: {
      authorizationToken: "",
      plan: {
        id: 0,
        period: 0,
        price: 0,
        original: 0
      },
      user: {
        name: "",
        email: "",
        pass: "",
        confirm: "",
        tosTime: 0
      },
      client: {
        type: "1",
        doc: "",
        phone: "",
        razao: "",
        fantasia: ""
      },
      address: {
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: ""
      },
      billing: {
        discountCode: "",
        installments: 1,
        type: "1",
        card: {
          number: "",
          holder: "",
          expire: "",
          cvv: "",
          cpf: ""
        },
        address: {
          cep: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          city: "",
          state: ""
        }
      }
    },
    discountCode: {
      loading: false,
      show: false,
      code: "",
      status: "error",
      msg: ""
    },
    rules: {
      required: [(v) => !!v || "Obrigatório"],
      emailRules: [
        (v) => !!v || "Um E-Mail é necessário",
        (v) => /.+@.+\..+/.test(v) || "O E-Mail precisa ser válido"
      ],
      passRules: [
        (v) => !!v || "Uma senha é obrigatória",
        (v) =>
          (v && v.length >= 8) || "A senha precisa ter pelo menos 8 caracteres"
      ],
      dateCard: [
        (v) => !!v || "Obrigatório",
        (v) => (v && v.length == 7) || "Data em MM/AAAA"
      ]
    },
    validDoc: true
  }),
  computed: {
    isMobile: function() {
      const mainBody = document.body;
      if (mainBody != null) {
        return mainBody.offsetWidth <= 600;
      }
      return false;
    },
    formatPlanResumeInfo: function() {
      let name = "";
      let period = "";
      const original = this.registerInfo.plan.original;
      const price = this.registerInfo.plan.price;
      this.plans.forEach((element) => {
        if (this.registerInfo.plan.id == element.id) {
          name = element.name;
        }
      });
      if (this.selectedDays == 30) period = "Mensal";
      if (this.selectedDays == 90) period = "Trimestral";
      if (this.selectedDays == 365) period = "Anual";
      const discount = original - price <= 0 ? 0 : original - price;
      return {
        name,
        period,
        hasDiscount: discount != 0,
        discountPerc: ((1 - price / original) * 100).toFixed(1),
        discount: "R$ " + this.formatAsPrice(discount),
        original: "R$ " + this.formatAsPrice(original),
        price: "R$ " + this.formatAsPrice(price)
      };
    },
    validCupom: function() {
      if (this.registerInfo.billing.discountCode == "") return true;
      if (this.registerInfo.billing.discountCode != this.discountCode.code)
        return false;
      if (this.discountCode.status == "success") return true;
      return false;
    },
    ...mapState({
      isLoggedIn: (state) => state.appStore.isLoggedIn,
      plans: (state) => state.planStore.plans
    })
  },
  methods: {
    formatAsPrice: function(price) {
      return price
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        .replace(/(.*)(\.)(\d{2})/g, "$1,$3");
    },
    formatFinalValue: function(prices) {
      let item = [];

      prices.forEach((element) => {
        if (element.days == this.selectedDays) {
          item = element;
        }
      });
      if (item.length == 0) {
        return {
          old: this.formatAsPrice(0),
          new: this.formatAsPrice(0),
          month: this.formatAsPrice(0)
        };
      }
      return {
        old: this.formatAsPrice(item.original),
        new: this.formatAsPrice(item.new_price),
        month: this.formatAsPrice(item.new_price / item.months)
      };
    },
    formatPeriodPlan: function(item) {
      if (item.original == 0) return "Gratuito";

      let periodText = "";
      if (item.days == 30) periodText = "Mensal";
      if (item.days == 90) periodText = "Trimestral";
      if (item.days == 365) periodText = "Anual";
      return periodText;
    },
    formatDiscountPlan: function(item) {
      let discount = "";
      if (item.discount == 0) discount = "Sem desconto";
      else discount = item.discount + "% OFF";
      return discount;
    },
    selectPlan: function(PlanId) {
      this.plans.forEach((element) => {
        if (element.id == PlanId) {
          if (element.free) {
            this.registerInfo.plan.id = PlanId;
            this.registerInfo.plan.period = 365;
            this.registerInfo.plan.price = 0;
            this.registerInfo.plan.original = 0;
            this.menuIndex = 1;
            return true;
          }
          element.prices.forEach((element) => {
            if (element.days == this.selectedDays) {
              this.registerInfo.plan.id = PlanId;
              this.registerInfo.plan.period = element.days;
              this.registerInfo.plan.price = element.new_price;
              this.registerInfo.plan.original = element.new_price;
              this.registerInfo.billing.installments = 1;
              this.menuIndex = 1;
              return true;
            }
          });
        }
      });

      return false;
    },
    validCpf: function(cpf) {
      if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      )
        return false;
      let soma = 0;
      let resto;
      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    validCnpj: function(cnpj) {
      if (
        !cnpj ||
        cnpj.length != 14 ||
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) return false;
      return true;
    },
    validateDoc: function() {
      let response = false;
      const doc = this.registerInfo.client.doc.replace(/\D+/g, "");
      if (this.registerInfo.client.doc.length == 14) {
        response = this.validCpf(doc);
      }
      if (this.registerInfo.client.doc.length >= 18) {
        response = this.validCnpj(doc);
        if (response) {
          this.getPjInfo(doc);
        }
      }
      this.validDoc = response;
    },
    getPjInfo: function(cnpj) {
      if (!this.reCaptchaPassed) return false;
      Axios.get("/api/v1/checkcnpj", {
        params: {
          cnpj
        }
      })
        .then((response) => {
          if (response.data.status == "success") {
            const info = response.data.info;
            this.registerInfo.client.razao = info.razao;
            this.registerInfo.client.fantasia = info.fantasia;
            this.registerInfo.address.cep = info.cep;
            this.registerInfo.address.street = info.street;
            this.registerInfo.address.number = info.street_number;
            this.registerInfo.address.complement = info.complement;
            this.registerInfo.address.neighborhood = info.neighborhood;
            this.registerInfo.address.city = info.city;
            this.registerInfo.address.state = info.state;
          } else {
            this.registerInfo.client.razao = "";
            this.registerInfo.client.fantasia = "";
            this.registerInfo.address.cep = "";
            this.registerInfo.address.street = "";
            this.registerInfo.address.number = "";
            this.registerInfo.address.complement = "";
            this.registerInfo.address.neighborhood = "";
            this.registerInfo.address.city = "";
            this.registerInfo.address.state = "";
          }
        })
        .catch(() => {
          //
        });
    },
    getAddress: function(billing = false) {
      if (!this.reCaptchaPassed) return false;
      let cep = null;
      if (billing) {
        cep = this.registerInfo.billing.address.cep.replace("-", "");
      } else {
        cep = this.registerInfo.address.cep.replace("-", "");
      }
      const address = {
        cep,
        street: "",
        complement: "",
        number: "",
        neighborhood: "",
        city: "",
        state: ""
      };
      Axios.get("/api/v1/checkcep", {
        params: {
          cep
        }
      })
        .then((response) => {
          if (response.data.status == "success") {
            const info = response.data.info;
            address.street = info.street;
            address.number = "";
            address.complement = info.complement;
            address.neighborhood = info.neighborhood;
            address.city = info.city;
            address.state = info.state;
          }
          if (billing) {
            const number = this.registerInfo.billing.address.number;
            const complement = this.registerInfo.billing.address.complement;
            this.registerInfo.billing.address = address;
            this.registerInfo.billing.address.number = number;
            this.registerInfo.billing.address.complement = complement;
          } else {
            const number = this.registerInfo.address.number;
            const complement = this.registerInfo.address.complement;
            this.registerInfo.address = address;
            this.registerInfo.address.number = number;
            this.registerInfo.address.complement = complement;
          }
        })
        .catch(() => {
          //
        });
    },
    setBillingAddress: function() {
      this.registerInfo.billing.address = this.registerInfo.address;
    },
    updateInstallments: function() {
      let installments = [];
      const value = this.registerInfo.plan.price;
      this.plans.forEach((plan) => {
        if (plan.id == this.registerInfo.plan.id) {
          plan.prices.forEach((price) => {
            if (price.days == this.selectedDays) {
              installments = price.installments;
            }
          });
        }
      });
      this.allowedInstallments = [];
      installments.forEach((parcela) => {
        const intParcela = parseInt(parcela);
        const formatedValue = this.formatAsPrice(value / intParcela);
        this.allowedInstallments.push({
          value: intParcela,
          text: intParcela + "x de R$ " + formatedValue
        });
      });
      if (this.allowedInstallments.length == 0) {
        const formatedValue = this.formatAsPrice(value);
        this.allowedInstallments.push({
          value: 1,
          text: "1x de R$ " + formatedValue
        });
      }
      this.installmentsRef = +new Date();
    },
    validateForm: function() {
      if (this.$refs.form.validate()) {
        this.updateInstallments();
        this.menuIndex = 2;
      }
    },
    finalizeRegister: async function() {
      if (!this.loading) {
        this.loading = true;
        if (this.$refs.form.validate()) {
          let data = null;
          Swal.fire({
            title: "Confirmar cadastro utilizando estes dados?",
            showCancelButton: true,
            confirmButtonColor: "#60ba8e",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            cancelButtonColor: "#B80C09",
            reverseButtons: true,
            icon: "question",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              await this.$store
                .dispatch("authStore/registerNewUser", this.registerInfo)
                .then((dataReceived) => {
                  this.loading = false;
                  data = dataReceived;
                });
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then(() => {
            Swal.fire({
              title: data.title,
              text: data.msg,
              icon: data.status_code > 0 ? "success" : "error",
              confirmButtonColor: "#60ba8e",
              confirmButtonText: "OK"
            }).then(() => {
              if (data.status_code == -1) document.location.reload();
              if (data.status_code == -2) this.menuIndex = 1;
              if (data.status_code == -3) this.menuIndex = 2;
              if (data.status_code == 1) {
                const user = {
                  email: this.registerInfo.user.email,
                  password: this.registerInfo.user.pass,
                  remember: false
                };
                this.$store.dispatch("authStore/loginUser", user);
              }
            });
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      }
    },
    checkDiscount: function() {
      this.discountCode.loading = true;
      Axios.get("/api/v1/checkdiscount", {
        params: {
          id: this.registerInfo.plan.id,
          period: this.registerInfo.plan.period,
          cupom: this.registerInfo.billing.discountCode
        }
      })
        .then((response) => {
          if (response.data.checked) {
            const data = response.data;
            this.discountCode.status = data.status;
            this.discountCode.msg = data.msg;
            this.discountCode.code = this.registerInfo.billing.discountCode;
            this.discountCode.status = data.status;
            this.registerInfo.billing.type = "1";
            this.allowBoleto = data.boleto;
            if (data.status == "success") {
              this.registerInfo.plan.original = data.original;
              this.registerInfo.plan.price = data.new;
              this.updateInstallments();
            } else this.registerInfo.billing.discountCode = "";
            this.discountCode.show = true;
          } else this.registerInfo.billing.discountCode = "";
        })
        .catch(() => {
          this.registerInfo.billing.discountCode = "";
        })
        .finally(() => {
          this.discountCode.loading = false;
        });
    },
    gotoLogin: function() {
      this.$router.push("/login");
    },
    checkQuery: function() {
      const query = this.$router.history.current.query;
      let plan, period;
      try {
        plan = query.plan;
        period = query.period;
      } catch (ReferenceError) {
        plan = "";
        period = "";
      }
      if (typeof plan == "undefined" || typeof period == "undefined") {
        return true;
      }
      this.selectedDays = period;
      this.selectPlan(plan);
    },
    makeReCaptcha: async function() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      Axios.post("/api/v1/verify", {
        token,
        action: "register"
      }).then((response) => {
        if (response.data.pass == "success") {
          this.registerInfo.authorizationToken = response.data.authorization;
          this.reCaptchaPassed = true;
        }
      });
    }
  },
  async mounted() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
    this.loadingPlans = true;
    await this.$store.dispatch("planStore/getPlans").then(() => {
      this.checkQuery();
      this.loadingPlans = false;
    });
    this.makeReCaptcha();
  }
};
</script>
<style>
.plan-card {
  user-select: none;
}
.plan-title {
  text-align: center;
  color: #60ba8e;
  text-transform: uppercase;
  font-size: 20px;
}
.plan-subtitle {
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 15px;
  font-size: 14px;
}
.plan-item {
  text-align: center;
  padding-bottom: 10px;
  font-size: 14px;
}
.plan-reports {
  text-align: center;
  padding-bottom: 10px;
  font-size: 14px;
}
.plan-value-total {
  font-size: 18px;
}
.plan-value-sub {
  font-size: 14px;
  color: #11111195;
}
.plan-value {
  font-size: 30px;
  color: #132237;
}
.plan-value-min {
  font-size: 14px;
  color: #132237;
}

.user-data-title {
  color: #60ba8e;
  font-size: 32px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
}
.user-data-subtitle {
  color: #60ba8e;
  font-size: 20px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
}
.resume {
  border-left: #60ba8e solid 1px;
  color: #132237;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
}
.resume-info {
  font-weight: 600;
  font-size: 18px;
  color: #132237;
  margin-bottom: 4px !important;
}
.resume-parcelas {
  text-align: end;
  font-size: 14px;
  color: #132237ee;
  margin-bottom: 4px !important;
}
.resume-cupom {
  font-size: 14px;
  color: #132237ee;
  margin-bottom: 4px !important;
}
.title-billing {
  font-weight: 500;
  color: #60ba8e;
  font-size: 16px;
}
.sub-billing {
  text-decoration: underline;
  color: #13223795;
  cursor: pointer;
  font-size: 13px;
}
.googleReCaptcha {
  font-size: 10px;
  padding-right: 20px;
  user-select: none;
  color: #11111188;
  z-index: 1;
  float: right;
}
.grecaptcha-badge {
  visibility: hidden;
}
.stepperMobile {
  text-align: center;
}
</style>
